import React from 'react';

/**
 * Stepper component for showing progress in the publish flow
 * Displays horizontal dots with connecting lines
 */

interface StepperProps {
  currentStep: number;
  totalSteps: number;
}

const Stepper: React.FC<StepperProps> = ({ currentStep, totalSteps }) => {
  return (
    <div className="flex items-center justify-start gap-3 px-6 py-4">
      {Array.from({ length: totalSteps }).map((_, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < currentStep;
        const isActive = stepNumber === currentStep;

        return (
          <React.Fragment key={stepNumber}>
            {/* Dot */}
            <div
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                isCompleted
                  ? 'bg-[#22c55e] shadow-[0_0_12px_rgba(34,197,94,0.6)]'
                  : isActive
                  ? 'bg-[#22c55e] shadow-[0_0_12px_rgba(34,197,94,0.6)] scale-110'
                  : 'bg-white/20'
              }`}
            />
            
            {/* Line between dots (not after last dot) */}
            {stepNumber < totalSteps && (
              <div
                className={`h-0.5 w-8 transition-all duration-300 ${
                  isCompleted ? 'bg-[#22c55e]' : 'bg-white/10'
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Stepper;

